import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useProduct, useUpdateProduct } from "../hooks";
import { ProductForm } from "../components";

type IUpdateProduct = {
  id: string;
};

export const UpdateProduct: React.FC = () => {
  const { id } = useParams<IUpdateProduct>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useProduct(+id!);
  const { form, submit, loading } = useUpdateProduct({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le produit a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.product?.ok && data?.product?.result) {
      const { result } = data.product;
      form.setValue("name", result.name);
      form.setValue("url", result.url);
      form.setValue("imgUrl", result.imgUrl);
      form.setValue("reference", result.reference);
      form.setValue("lastPrice", result.lastPrice);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Produit"
        subtitle={data?.product?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/product/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un produit" />
          <ProductForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
